/* flex-pdp-pair.js
   PRODUCT pages only.
   Adds phone + paired service together, and prevents double submit.
   - Replaces the default Flex error with a clearer inventory/limit message when service plans run out
*/
(() => {
  "use strict";

  if (window.__FLEX_PDP_PAIR_LOADED__) return;
  window.__FLEX_PDP_PAIR_LOADED__ = true;

  const SERVICE_HANDLE = "ting-sim-card-add";
  const ROLE_PHONE = "phone";
  const ROLE_SERVICE = "service";

  const DEFAULT_FLEX_ERROR = "Could not add Flex plan automatically. Please try again.";
  const FRIENDLY_FLEX_ERROR =
    "Flex Mobile plan limit reached. We couldn't add another Flex Mobile plan because there isn't enough plan inventory available right now.\n\n" +
    "Please remove a device, or continue with the plans already in your cart.";

  let serviceVariantIdCache = null;
  let serviceVariantPromise = null;

  async function fetchJSON(url, opts) {
    const r = await fetch(url, { credentials: "same-origin", ...opts });

    const text = await r.text();
    let data = null;
    try {
      data = text ? JSON.parse(text) : null;
    } catch (e) {}

    if (!r.ok) {
      const err = new Error(`${url} failed (${r.status})`);
      err.status = r.status;
      err.data = data;
      err.rawText = text;
      throw err;
    }

    return data;
  }

  async function getServiceVariantId() {
    if (serviceVariantIdCache) return serviceVariantIdCache;
    if (serviceVariantPromise) return serviceVariantPromise;

    serviceVariantPromise = (async () => {
      const p = await fetchJSON(`/products/${SERVICE_HANDLE}.js`);
      const v = (p?.variants || [])[0];
      serviceVariantIdCache = v?.id || null;
      serviceVariantPromise = null;
      return serviceVariantIdCache;
    })();

    return serviceVariantPromise;
  }

  function uid() {
    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }

  function looksLikeInventoryLimitError(err) {
    const status = err?.status;
    const msg = String(err?.data?.message || "").toLowerCase();
    const desc = String(err?.data?.description || "").toLowerCase();
    const raw = String(err?.rawText || err?.message || "").toLowerCase();
    const hay = `${msg} ${desc} ${raw}`;

    const inventoryHints =
      hay.includes("sold out") ||
      hay.includes("not enough") ||
      hay.includes("inventory") ||
      hay.includes("unavailable") ||
      hay.includes("cannot be added") ||
      hay.includes("can't add") ||
      hay.includes("cannot add");

    return status === 422 && inventoryHints;
  }

  function showError(err) {
    if (looksLikeInventoryLimitError(err)) {
      alert(FRIENDLY_FLEX_ERROR);
      return;
    }
    alert(DEFAULT_FLEX_ERROR);
  }

  async function addPaired(form) {
    const fd = new FormData(form);

    const variantId = Number(fd.get("id"));
    const qty = Math.max(1, Number(fd.get("quantity") || 1));

    const isPhone = fd.get("is_phone") === "1";
    const feeHandle = fd.get("flex_fee_handle");
    if (!isPhone || !feeHandle) return false;

    const serviceVariantId = await getServiceVariantId();
    if (!serviceVariantId) throw new Error("No service variant id found");

    const pairId = uid();

    const items = [
      {
        id: variantId,
        quantity: qty,
        properties: { _flex_role: ROLE_PHONE, _flex_pair_id: pairId },
      },
      {
        id: serviceVariantId,
        quantity: qty,
        properties: { _flex_role: ROLE_SERVICE, _flex_pair_id: pairId },
      },
    ];

    await fetchJSON("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    });

    return true;
  }

  function init() {
    const forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    if (!forms.length) return;

    forms.forEach((form) => {
      if (form.dataset.flexBound === "1") return;
      form.dataset.flexBound = "1";

      form.addEventListener(
        "submit",
        async (e) => {
          const fd = new FormData(form);
          const isPhone = fd.get("is_phone") === "1";
          const feeHandle = fd.get("flex_fee_handle");

          if (!isPhone || !feeHandle) return;

          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          if (form.dataset.flexBusy === "1") return;
          form.dataset.flexBusy = "1";

          const btn = form.querySelector('button[name="add"]');
          if (btn) btn.setAttribute("disabled", "disabled");

          try {
            await addPaired(form);
            window.location.href = "/cart";
          } catch (err) {
            console.warn("[Flex PDP] add failed:", err);
            showError(err);
            if (btn) btn.removeAttribute("disabled");
            form.dataset.flexBusy = "0";
          }
        },
        true
      );
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();